import { http } from './client';
import type {
  ChatFeedbackChannel,
  ChatFeedbackRating,
  ChatMessageFeedback,
  FeedbackRecord,
  FeedbackStatus,
  PageResult,
} from './types';

export interface ListFeedbackParams {
  limit?: number;
  cursor?: string;
  username?: string;
  status?: FeedbackStatus;
}

export interface ListChatFeedbackParams {
  limit?: number;
  cursor?: string;
  rating?: ChatFeedbackRating;
  channel?: ChatFeedbackChannel;
}

export const feedbackApi = {
  async list(params: ListFeedbackParams = {}): Promise<PageResult<FeedbackRecord>> {
    const res = await http.get<PageResult<FeedbackRecord>>('/v1/bot/feedback', { params });
    return res.data;
  },

  async get(id: string): Promise<FeedbackRecord> {
    const res = await http.get<FeedbackRecord>(`/v1/bot/feedback/${encodeURIComponent(id)}`);
    return res.data;
  },

  async delete(id: string): Promise<{ deleted: true; feedbackId: string }> {
    const res = await http.delete<{ deleted: true; feedbackId: string }>(
      `/v1/bot/feedback/${encodeURIComponent(id)}`,
    );
    return res.data;
  },

  async listChat(
    params: ListChatFeedbackParams = {},
  ): Promise<PageResult<ChatMessageFeedback>> {
    const res = await http.get<PageResult<ChatMessageFeedback>>('/v1/bot/chat/feedback', {
      params,
    });
    return res.data;
  },
};
